import { productoConstants } from '../_constants';

export function producto(state = {}, action) {
  switch (action.type) {
    case productoConstants.REFRESH_CART:
      return {
        ...state,
        value: action.data.value
      };
    case productoConstants.GETALL_SUCCESS_CANDADO:
      return {
        ...state,
        listado: action.productos
      };
    case productoConstants.GETALL_FAILURE_CANDADO:
      return { 
        ...state,
        error: action.error
      };    
    default:
      return state
  }
}